import {
  Slide,
  TextProps,
  TextPropsTextConfig,
  ZERO_WIDTH_SPACE,
  parseContent,
} from '@features/powerpoint';
import { theme } from '@features/executive-report/domain/theme';
import { lightbulbOutlineWhite } from '@features/executive-report/images';
import { DEFAULT_SLIDE_MASTER } from '@features/executive-report/slides/slide-master';

export const recommendationsSlide = (
  recommendations: string[],
  headerTexts: TextProps[]
): Slide => ({
  slideMaster: DEFAULT_SLIDE_MASTER,
  texts: [
    ...headerTexts,
    {
      text: 'Recommendations',
      options: {
        fontSize: 40,
        color: theme.colors.inmarketGreen,
        charSpacing: theme.charSpacing.tight,
        bold: true,
        h: 0.77,
        w: 6.37,
        x: 0.8,
        y: 4.08,
      },
    },
    {
      text: recommendations.flatMap((recommendation): TextPropsTextConfig[] => [
        {
          text: ZERO_WIDTH_SPACE,
          options: {
            color: theme.colors.inmarketGreen,
            fontSize: 20,
            bullet: true,
          },
        },
        ...parseContent(recommendation),
      ]),
      options: {
        fontSize: 18,
        color: theme.colors.white,
        valign: 'top',
        paraSpaceAfter: 18,
        h: 4.52,
        w: 5.09,
        x: 7.5,
        y: 2.27,
      },
    },
  ],
  shapes: [
    {
      shapeName: 'line',
      options: {
        line: {
          color: theme.colors.inmarketGreen,
          width: 2.25,
        },
        h: 3.67,
        w: 0,
        x: 7.03,
        y: 1.96,
      },
    },
    {
      shapeName: 'ellipse',
      options: {
        line: {
          color: theme.colors.inmarketGreen,
          width: 2,
        },
        h: 1.34,
        w: 1.34,
        x: 0.8,
        y: 2.59,
      },
    },
  ],
  images: [
    {
      path: lightbulbOutlineWhite,
      h: 0.85,
      w: 0.85,
      x: 1.05,
      y: 2.88,
    },
  ],
});
